export function richTextContent(legalTerms) {
    if (isPDF(legalTerms)) {
        return [];
    }
    return typeof legalTerms.richTextContent[0] === 'string' ? legalTerms.richTextContent.map((v)=>JSON.parse(v)) : legalTerms.richTextContent;
}
export function isPDF(legalTerms) {
    return legalTerms.contentType === 'pdf';
}
export function isRichText(legalTerms) {
    return legalTerms.contentType === 'richText';
}
export function isQuill(legalTerms) {
    return legalTerms.contentType === 'quill';
}
export function isEditable(legalTerms) {
    return isQuill(legalTerms) && legalTerms.origin === 'custom';
}
export function isDuplicatable(legalTerms) {
    return isQuill(legalTerms) || isRichText(legalTerms);
}
export function name(legalTerms) {
    return legalTerms.name;
}
export function textId(legalTerms) {
    var _legalTerms_richTextId;
    if (isPDF(legalTerms)) {
        return undefined;
    }
    return (_legalTerms_richTextId = legalTerms.richTextId) !== null && _legalTerms_richTextId !== void 0 ? _legalTerms_richTextId : undefined;
}
